import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";

import {FirebaseAppProvider,PerformanceProvider} from "reactfire";

import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";

import firebaseConfig from "./firebase/firebaseConfig";

import {QueryClient,QueryClientProvider} from "@tanstack/react-query";
//import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const app = initializeApp(firebaseConfig);
const performance = getPerformance(app);

const queryClient = new QueryClient();

ReactDOM.render((
    <QueryClientProvider client={queryClient}>
        <FirebaseAppProvider firebaseConfig={firebaseConfig} >
            <PerformanceProvider sdk={performance}>
                <App />
                {/* <ReactQueryDevtools/> */}
            </PerformanceProvider>
        </FirebaseAppProvider>
    </QueryClientProvider>
), document.getElementById("root"));
